import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { Subject, catchError, merge, of, switchMap, timer } from 'rxjs';
import { MulesoftService } from '../../../features/home/services/mulesoft.service';

@Component({
  selector: 'app-sap-token-button',
  templateUrl: './sap-token-button.html',
  styleUrls: ['./sap-token-button.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ]
})
export class SapTokenButton implements OnInit {
  private readonly mulesoftService = inject(MulesoftService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly tokenValidationIntervalMs = 2 * 60 * 1000;
  private readonly tokenGenerated$ = new Subject<void>();
  private tokenChannel?: BroadcastChannel;
  public readonly isTokenValid = signal<boolean>(false);
  public readonly tokenStatus = signal<string>('Active');
  public readonly tokenExpiresIn = signal<string>('1h');

  ngOnInit(): void {
    this.listenForTokenGeneration();

    merge(
      timer(60 * 1000, this.tokenValidationIntervalMs),
      this.tokenGenerated$,
    )
      .pipe(
        switchMap(() =>
          this.mulesoftService.ValidTokens().pipe(catchError(() => of(null)))
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((response) => {
        if (!response) {
          this.isTokenValid.set(false);
          this.tokenStatus.set('Inactive');
          this.tokenExpiresIn.set('N/A');
          sessionStorage.setItem('isTokenValid', JSON.stringify(false));
          return;
        }

        sessionStorage.setItem('isTokenValid', JSON.stringify(response.isValidToken));
        this.isTokenValid.set(response.isValidToken);
        this.tokenStatus.set(response.isValidToken ? 'Active' : 'Inactive');
        this.tokenExpiresIn.set(
          response.expiresTime != null ? `${response.expiresTime}min` : 'N/A'
        );
      });
  }

  private listenForTokenGeneration(): void {
    try {
      this.tokenChannel = new BroadcastChannel('sap-token');
      this.tokenChannel.onmessage = () => this.tokenGenerated$.next();
      this.destroyRef.onDestroy(() => this.tokenChannel?.close());
    } catch {
      // BroadcastChannel not available - fall back to interval only
    }
  }

  getIconName(): string {
    return this.isTokenValid() ? 'token' : 'token';
  }

  getIconColor(): string {
    return this.isTokenValid() ? 'accent' : 'warn';
  }
  generateSamlAssertion(isClick: boolean): void {
    this.mulesoftService.getToken('deviation',isClick);
  }

  getTooltip(): string {
    const status = this.isTokenValid() ? 'Active' : 'Inactive';
    return `SAP Token: ${status} (Expires: ${this.tokenExpiresIn()})`;
  }
}
